"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How often are the name lists updated?",
  answer: "We update our trending and popular name lists monthly to ensure you have access to the most current naming trends. Our unique and biblical name databases are reviewed quarterly for accuracy and new additions."
}, {
  question: "Can I suggest a name to be added to the database?",
  answer: "Absolutely! We love hearing from our community. While we don't have a direct submission form yet, you can reach out to us via our contact email with your suggestions, and our team will review them for inclusion."
}, {
  question: "What does 'Trending Names' mean?",
  answer: "Our 'Trending Names' list highlights names that are currently experiencing a rapid increase in popularity based on recent search data, birth registries, and cultural trends. These are the names modern parents are loving right now."
}, {
  question: "Are the name meanings accurate?",
  answer: "We strive for the highest accuracy by cross-referencing multiple etymological dictionaries and historical sources. However, many names have evolved over centuries and across different cultures, so some may have multiple valid meanings."
}, {
  question: "Is NamesOfTheWorld.com completely free to use?",
  answer: "Yes, our website and all of our comprehensive name lists are completely free for everyone to browse and use. We are dedicated to providing a beautiful, accessible resource for parents everywhere."
}];
export default function CommonQuestions() {
  return <section id="common-questions" className="bg-background py-16 px-4 md:px-8">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-[var(--chart-1)] mb-10 text-center">
          Frequently Asked Questions
        </h2>
        
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-[var(--chart-1)]">
              <AccordionTrigger className="group py-6 hover:no-underline [&>svg:last-child]:hidden">
                <span className="text-[var(--chart-1)] font-semibold text-left text-lg md:text-xl">
                  {faq.question}
                </span>
                <span className="shrink-0 ml-4 flex items-center justify-center">
                  <Plus className="size-6 text-[var(--secondary)] transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[var(--foreground)] text-base md:text-lg pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}